module.exports = __webpack_public_path__ + "static/media/image_9.64a613b6.jpg";